var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dataset-filter-form"}},[_c('dataset-state-select',{on:{"dataset-state-changed":function($event){_vm.datasetState = $event}}}),_c('datasets-per-page',{attrs:{"datasets-per-page-default":_vm.datasetsPerPageDefault},on:{"datasets-per-page-changed":function($event){_vm.perPage = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }